import { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function CatalogSection() {
  const [newsletterData, setNewsletterData] = useState({
    nome: '',
    email: '',
    empresa: '',
    interesse: ''
  });
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const catalogs = [
    {
      id: 1,
      title: 'Catálogo Completo 2024',
      description: 'Linha completa de produtos para food service',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/cd2b4ba02c789eae2ccf9df4d1a5f340.png',
      pages: '48 páginas',
      downloadUrl: 'https://www.tecnutrifoodservice.com.br/up/anexo/1730986540.pdf'
    },
    {
      id: 2,
      title: 'Linha de Sobremesas',
      description: 'Gelatinas, mousses, pudins e muito mais',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/0c60f91c52da76d2581c87a2e21529b7.jpeg',
      pages: '24 páginas',
      downloadUrl: 'https://www.tecnutrifoodservice.com.br/up/anexo/1698421311.jpg'
    },
    {
      id: 3,
      title: 'Bebidas e Refrescos',
      description: 'Refrescos, achocolatados e chocolates',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/7d2873d74422ea05ecaca305f3a605e9.png',
      pages: '16 páginas',
      downloadUrl: 'https://www.tecnutrifoodservice.com.br/up/anexo/1701185824.jpg'
    }
  ];

  const handleDownload = (catalog: any) => {
    const link = document.createElement('a');
    link.href = catalog.downloadUrl;
    link.download = `${catalog.title}.${catalog.downloadUrl.split('.').pop()}`;
    link.target = '_blank';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('nome', newsletterData.nome);
      formData.append('email', newsletterData.email);
      formData.append('empresa', newsletterData.empresa);
      formData.append('interesse', newsletterData.interesse);
      
      const response = await fetch('https://readdy.ai/api/form/d3m09ni96ie05rb9mf10', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        setSubmitMessage('Cadastro realizado com sucesso! Você receberá nossos catálogos em breve.');
        setNewsletterData({ nome: '', email: '', empresa: '', interesse: '' });
        setTimeout(() => {
          setShowNewsletterModal(false);
          setSubmitMessage('');
        }, 3000);
      } else {
        setSubmitMessage('Erro ao enviar cadastro. Tente novamente.');
      }
    } catch (error) {
      setSubmitMessage('Erro ao enviar cadastro. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-lg">Catálogos</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-6">
            Nossos Catálogos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Baixe nossos catálogos completos e conheça toda nossa linha de produtos desenvolvidos especialmente para o food service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {catalogs.map((catalog) => (
            <Card key={catalog.id} hover className="text-center group">
              <div className="aspect-[3/4] mb-6 overflow-hidden rounded-lg bg-gray-100">
                <img
                  src={catalog.image}
                  alt={catalog.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-xl text-gray-900 mb-2">
                    {catalog.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {catalog.description}
                  </p>
                </div>
                
                <div className="flex justify-center gap-6 text-sm text-gray-500 mb-6">
                  <span className="flex items-center">
                    <i className="ri-file-text-line mr-1"></i>
                    {catalog.pages}
                  </span>
                </div>
                
                <Button 
                  variant="primary" 
                  className="w-full"
                  onClick={() => handleDownload(catalog)}
                >
                  <i className="ri-download-line mr-2"></i>
                  Download Gratuito
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/catalogos">
            <Button variant="outline" size="lg">
              <i className="ri-folder-line mr-2"></i>
              Ver Todos os Catálogos
            </Button>
          </Link>
        </div>

        {/* Newsletter CTA */}
        <div className="mt-16 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Receba Nossos Catálogos por E-mail
          </h3>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Cadastre-se em nossa newsletter e seja o primeiro a receber nossos novos catálogos e lançamentos
          </p>
          <Button 
            variant="outline" 
            size="lg" 
            className="border-white text-white hover:bg-white hover:text-red-600"
            onClick={() => setShowNewsletterModal(true)}
          >
            <i className="ri-mail-line mr-2"></i>
            Cadastrar Agora
          </Button>
        </div>
      </div>

      {/* Newsletter Modal */}
      {showNewsletterModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Cadastre-se</h3>
              <button
                onClick={() => setShowNewsletterModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
            
            <form onSubmit={handleNewsletterSubmit} data-readdy-form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  name="nome"
                  required
                  value={newsletterData.nome}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, nome: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="Seu nome completo"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  value={newsletterData.email}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, email: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="seu@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Empresa
                </label>
                <input
                  type="text"
                  name="empresa"
                  value={newsletterData.empresa}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, empresa: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500"
                  placeholder="Nome da sua empresa"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Interesse Principal
                </label>
                <select
                  name="interesse"
                  value={newsletterData.interesse}
                  onChange={(e) => setNewsletterData(prev => ({ ...prev, interesse: e.target.value }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 pr-8"
                >
                  <option value="">Selecione uma categoria</option>
                  <option value="bebidas">Bebidas e Refrescos</option>
                  <option value="sobremesas">Sobremesas</option>
                  <option value="culinarios">Produtos Culinários</option>
                  <option value="todos">Todos os Produtos</option>
                </select>
              </div>
              
              {submitMessage && (
                <div className={`p-3 rounded-lg text-sm ${
                  submitMessage.includes('sucesso') 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-red-100 text-red-800'
                }`}>
                  {submitMessage}
                </div>
              )}
              
              <Button 
                type="submit" 
                className="w-full" 
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="ri-mail-send-line mr-2"></i>
                    Cadastrar
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
